import CommonChestContain from '../../../assets/images/chests/rewards/common-chest-contain.png';
import EpicChestContain from '../../../assets/images/chests/rewards/epic-chest-contain.png';
import LegendaryChestContain from '../../../assets/images/chests/rewards/legendary-chest-contain.png';
import RareChestContain from '../../../assets/images/chests/rewards/rare-chest-contain.png';
import { TChestRewardVariant } from '../../../types';

const className = 'w-full h-full';

export const getChestContainIcon = (variant: TChestRewardVariant) => {
  switch (variant) {
    case 'legendary':
      return <img src={LegendaryChestContain} alt="legendary-chest-contain" className={`${className}`} />;
    case 'epic':
      return <img src={EpicChestContain} alt="epic-chest-contain" className={`${className}`} />;
    case 'rare':
      return <img src={RareChestContain} alt="rare-chest-contain" className={`${className} transform scale-[1.2]`} />;
    case 'common':
      return <img src={CommonChestContain} alt="common-chest-contain" className={`${className} transform scale-[1.2]`} />;
    default:
      return <img src={CommonChestContain} alt="common-chest-contain" className={`${className} transform scale-[1.2]`} />;
  }
};
